<template>
  <grid :config="{searchFields: ['name']}" :data="organisations"
        class="u-1-of-1">
    <template v-slot:gridHeader>
      <div class="o-layout c-list__row u-padding-horizontal-small">
        <div class="o-layout__item u-2-of-3-at-small">
          {{$t('name')}}
        </div>
        <div class="o-layout__item u-1-of-6-at-small">
          {{$t('role')}}
        </div>
        <div class="o-layout__item u-1-of-6-at-small">
          &nbsp;
        </div>
      </div>
    </template>
    <template v-slot:gridData="{element}">
      <div class="o-layout__item u-2-of-3-at-small c-list__main-cell">
        {{element.name}}
      </div>
      <div class="o-layout__item u-1-of-6-at-small c-list__main-cell">
        {{ $t('role.' + element.role) }}
      </div>
      <div class="o-layout__item u-1-of-6-at-small c-list__main-cell">
        <sceButton class="c-button--tertiary c-button--small" @click="gotoOrganisation(element.organisationId, element.name)">
          {{$t('open')}}
        </sceButton>
      </div>
    </template>
  </grid>

</template>

<script>
import sortBy from "lodash/sortBy"

export default {
  name: "userOrganisations",
  components: {
    grid: require('client/components/dataGrid.vue').default,
  },
  computed: {
    organisations: function() {
      return sortBy(this.$store.state.user.organisations, 'name')
    },
  },
  methods: {
    gotoOrganisation: function(organisationId, name) {
      // switch to a new organisation and then navigate to that organisation
      this.$notify.notifyAsync(
        this.$store.dispatch('user.switchOrganisation', organisationId),
        this.$t('user.organisation.switching') + ':\n' + name,
        () => {
          this.$router.push({ name: 'organisation.events', params: { organisationId } })
          return this.$t('user.organisation.switched')},
        (err) => {
          return this.$t('user.organisation.switchFailed') + '\n' + err.message
        }
      )
    },
  },
}
</script>

<style scoped>

</style>
